import React from 'react';
import { initializeIcons } from '@fluentui/react';
import { AppLayout } from './components/AppLayout/AppLayout';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import UserManagement from './pages/administration/UserManagement';
import ChangePassword from './pages/ChangePassword';
import { ApplicationContext } from './contexts/ApplicationContext';
import { CommonServices } from './services/ICommonServices';
import styles from './styles/App.module.scss';
import { ErrorPage } from './components/AppLayout/ErrorPage';
import { AuthenticationProvider } from './authentication/AuthenticationProvider';
import Dashboard from './pages/Dashboard';
import RequireAuth from './authentication/RequireAuth';
import Sales from './pages/Sales';
import { Banks, Codes, Company, Misc, Nets, Rates, TaxGroups, Turbines, Users } from './pages/settings';
import { ServiceLetter } from './pages/ServiceLetter';
import Payout from './pages/Payout';
import { TopNavigation } from './components/AppLayout/TopNavigation';
import Settings from './pages/settings/Settings';
import Login from './pages/login/Login';
import ProductionOverview from './pages/ProductionOverview';
import Stakeholders from './pages/stakeholders/Stakeholders';
import CookieConsent from "react-cookie-consent";
import Clarity from '@microsoft/clarity';
import SignedOut from './pages/login/SignedOut';

export const App: React.FunctionComponent<{}> = (props: React.PropsWithChildren<{}>) => { 
    React.useEffect(() => { initializeIcons(); }, []);
    
    const router = createBrowserRouter([
    {
        path: "/",
        element: <RequireAuth redirectTo="/Login"><TopNavigation /><AppLayout /></RequireAuth>,
        errorElement: <ErrorPage />,          
        //loader: rootLoader,
        children: [
            {
                path: "/",
                element: <Dashboard />,
            },
            {
                path: "interessenter",
                element: <Stakeholders />,
            },
            {
                path: "køb-salg",
                element: <Sales />,
            },            
            {
                path: "udbetalinger",
                element: <Payout />,
            },
            {
                path: "servicebreve",
                element: <ServiceLetter />,
            },
            {
                path: "produktionsoversigt",
                element: <ProductionOverview />,
            },
            {
                path: "indstillinger",
                element: <Settings />,
            },
            {
                path: "indstillinger/firma",
                element: <Company />,
            },
            {
                path: "indstillinger/banker",
                element: <Banks />,
            },
            {
                path: "indstillinger/nets",
                element: <Nets />,
            },
            {
                path: "indstillinger/skattegrupper",
                element: <TaxGroups />,
            },
            {
                path: "indstillinger/ajourkoder",
                element: <Codes />,
            },
            {
                path: "indstillinger/satser",
                element: <Rates />,
            },
            {
                path: "indstillinger/vindmøller",
                element: <Turbines />,
            },
            {
                path: "indstillinger/brugere",
                element: <Users />,
            },
            {
                path: "indstillinger/diverse",
                element: <Misc />,
            },
            {
                path: "/skift-adgangskode",
                element: <ChangePassword />,
            },
            {
                path: "/brugeradministration",
                element: <UserManagement />,
            },
        ],
    },
    {
        path: "/Login",
        errorElement: <ErrorPage />,   
        element: <Login />
    },
    {
        path: "/Logget-ud",
        errorElement: <ErrorPage />,   
        element: <SignedOut />
    }
    ]);

    Clarity.init("rppt8atkb3");

    return (
        <div className={styles.app}>
            <div className={styles.header}>
                <div className={styles.logo}><a href={`/`}><img src="images/logo.png" alt="Uhrevind"/><h1>Uhrevind</h1></a></div>                
            </div>
            <AuthenticationProvider>
                <ApplicationContext.Provider value={{Services: new CommonServices()}}>
                        <RouterProvider router={router} />                    
                </ApplicationContext.Provider>
            </AuthenticationProvider>            
            <div className={styles.version}>App version: 0.0.9</div>
            <CookieConsent buttonText='Forstået 👌' cookieName='UhrevindApp_CookieConsent' style={{background:"#f0f0f0", color:"#000"}} buttonStyle={{ color: "#fff", background:"#059b05", fontSize: "14px" }}>Denne hjemmeside bruger cookies til at forbedre din brugeroplevelse.</CookieConsent>
      </div>
    );
}
  
export default App;